import { Component } from "@angular/core";

@Component({
    selector: "footer",
    imports: [],
    templateUrl: "./footer.component.html"
})
export class FooterComponent {

}
